import { domContentLoadEvent } from '../common/domContentLoadEvent';

function addCollapseButton(accordionElement) {
    const button = accordionElement.querySelector('.accordion-button');
    const container = accordionElement.querySelector('.accordion-container');

    if (!button || !container) {
        return;
    }

    button.addEventListener('click', function () {
        accordionElement.classList.toggle('active');

        //Fecha accordions do mesmo grupo
        const accordionGroup = accordionElement.getAttribute('accordion-group');
        document.querySelectorAll('.accordion[accordion-group="' + accordionGroup + '"]').forEach(function (elm) {
            if (elm !== accordionElement) {
                elm.classList.remove('active');
                elm.querySelector('.accordion-container').style.maxHeight = '0';
            }
        });

        //Expande container
        const isCollapsed = accordionElement.classList.contains('active');
        if (isCollapsed) {
            setTimeout(function () {
                document.addEventListener('click', outsideClickListener);
            }, 200);
            container.style.maxHeight = container.scrollHeight + 'px';
        } else {
            document.removeEventListener('click', outsideClickListener);
            container.style.maxHeight = '0';
        }
    });

    //Observable change height container
    new MutationObserver(function () {
        const isCollapsed = accordionElement.classList.contains('active');
        if (isCollapsed) {
            container.style.maxHeight = container.scrollHeight + 'px';
        } else {
            container.style.maxHeight = '0';
        }
    }).observe(container, { childList: true, subtree: true });

    const outsideClickListener = function (event) {
        const isClickInside = container.contains(event.target);
        if (!isClickInside) {
            accordionElement.classList.remove('active');
            container.style.maxHeight = '0';
            document.removeEventListener('click', outsideClickListener);
        }
    };
}

function addCollapseButtonsToCollapsableElements() {
    const collapsableElements = document.querySelectorAll('.accordion');

    collapsableElements.forEach((element) => {
        addCollapseButton(element);
    });
}

domContentLoadEvent(addCollapseButtonsToCollapsableElements);
